import { spacing } from '@util/spacing'
import styled from 'styled-components'

export const Logo = styled.img`
  height: 15px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.s16};
  border-bottom: 2px solid #f3f3f3;
  height: 4rem;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.s16};
  height: 100%;
  justify-content: space-between;

  button {
    width: 100%;
  }
`